import { Injectable } from '@angular/core';
import { GlobalIntervalService } from './global-interval-service.service';
import { DataAccessService } from './data-access.service';

interface AppStats {
    Services: any,
    Parts: any,
    VehicelSale: any,
    Accounts: any,
    Settings: any,
};

@Injectable()
export class StatsService {

    private subscribed: boolean = false;

    stats: AppStats = {
        Services: {
            Created: 0,
            WIP: 0,
            PaymentDue: 0
        },
        Parts: {
            Orders: 0,
            Backorder: 0,
            WIP: 0,
            PaymentDue: 0,
        },
        VehicelSale: {
            Stock: 0,
            Sales: 0,
            Orders: 0,
            Pricing: 0,
            Receiving: 0,
            Transfer: 0,
        },
        Accounts: {
            SupplierPayment: 0,
            Expenses: 0,
        },
        Settings: {
            Translations: 0,
        }
    };

    constructor(private globalInterval: GlobalIntervalService, private dataAccess: DataAccessService) {
        //if (!this.subscribed) {

        //    this.globalInterval._3SecondTick.subscribe((x) => {
        //        this.dataAccess.getAllStatsBackground().subscribe((x) => {
        //            //No need to set the stats here, The Interceptor will set these because 'AutoExpertAppStats' is returned on the response
        //            //this.stats = (x as unknown) as AppStats;
        //        });
        //    });

        //    this.subscribed = true;
        //}
    }
}